import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate | null> = (
  component,
  _currentRoute,
  _currentState,
  nextState,
) => {
  // Logout and session expiry clear the session before redirecting here — "Keep editing" would
  // strand the user on a page with no session, so leaving for /login is never blocked.
  if (nextState?.url.startsWith('/login')) return true;
  return component?.canDeactivate ? component.canDeactivate() : true;
};
